import {iFrameConnection} from "../../services/IFrameConnection";
import {IFrameMessages} from "../../../blink-sdk/messaging/IFrameMessages";
import {iFrameState} from "../../services/IFrameState";
import {PANEL_TYPE, PANEL_VARIANT} from "../../../blink-sdk/Constants";

export function startFlow(flowType, options={}) {
    iFrameConnection.sendToSDK(IFrameMessages.START_FLOW_REQUEST, {
        flowType,
        options: {
            type: flowType,
            ...iFrameState.transferredOptions,
            ...options,
        },
    });
}

export function startDonationFlow(variant=PANEL_VARIANT.skipCTA, oneTime=false) {
    if (oneTime) {
        startFlow(null, {
            type: PANEL_TYPE.donation,
            variant,
        });
    } else {
        startFlow(PANEL_TYPE.donation, {
            variant
        });
    }
}

export function startSubscriptionFlow(variant=PANEL_VARIANT.plain) {
    startFlow(PANEL_TYPE.subscribe, {
        variant
    });
}

export function startNewsletterFlow() {
    startFlow(null, {
        type: PANEL_TYPE.newsletter,
        variant: PANEL_VARIANT.skipCTA,
    });
}

export function startDashboardFlow() {
    startFlow(PANEL_TYPE.dashboard);
}
